import { render, staticRenderFns } from "./DomeTransactionDetailsModal.vue?vue&type=template&id=7a2fc9c7&"
import script from "./DomeTransactionDetailsModal.vue?vue&type=script&lang=ts&"
export * from "./DomeTransactionDetailsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports